export default __webpack_public_path__ + "static/media/glitch25.524f35ed.png";